import React from 'react';
import styled from 'styled-components';
import Skeleton from 'react-skeleton-loader';
import {
	Columns, Column
} from '../../base';
import media from '../../base/media';

const StyledLoader = styled.div`
	max-width: 1920px;
	margin: 0 auto;
	padding: 0 3rem;

	${media.tablet`
		padding: 0 6rem;
	`}
`;

const StyledMainImage = styled.div`
	border: 1px solid ${props => props.theme.colors.borderColor};
	border-radius: 4px;
	span {
		display: block;
	}

	.react-skeleton-load {
		padding-top: calc(50vh + 2px);
	}
`;

const StyledExtraImage = styled.div`
	border: 1px solid ${props => props.theme.colors.borderColor};
	border-radius: 4px;

	span {
		display: block;
	}

	.react-skeleton-load {
		padding-top: 25vh;
	}
`;

const StyledMainContent = styled.div`
	padding: 6rem 0;
`;

const StyledSpacer = styled.div`
	margin-top: 2rem;
`;

const StyledBox = styled.div`
	padding: 3rem;
	padding-bottom: 15rem;
	box-shadow: 0 7px 27px 0 rgba(147,94,196,0.1);
`;

const ApartmentDetailsLoader = () => {
	return (
		<StyledLoader>
			<Columns gapless>
				<Column gapless tablet="60%">
					<StyledMainImage>
						<Skeleton width="100%" height="0" widthRandomness="0" />
					</StyledMainImage>
				</Column>
				<Column gapless tablet="40%">
					<Columns gapless>
						<Column gapless tablet="50%">
							<StyledExtraImage>
								<Skeleton width="100%" height="0" widthRandomness="0" />
							</StyledExtraImage>
						</Column>
						<Column gapless tablet="50%">
							<StyledExtraImage>
								<Skeleton width="100%" height="0" widthRandomness="0" />
							</StyledExtraImage>
						</Column>
						<Column gapless tablet="50%">
							<StyledExtraImage>
								<Skeleton width="100%" height="0" widthRandomness="0" />
							</StyledExtraImage>
						</Column>
						<Column gapless tablet="50%">
							<StyledExtraImage>
								<Skeleton width="100%" height="0" widthRandomness="0" />
							</StyledExtraImage>
						</Column>
					</Columns>
				</Column>
			</Columns>
			<StyledMainContent>
				<Columns>
					<Column tablet="60%">
						<Skeleton width="40%" height="40px" widthRandomness="0" />
						<Skeleton width="40%" height="0px" widthRandomness="0" />
						<Skeleton width="20%" height="20px" widthRandomness="0" />
						<StyledSpacer />
						<StyledSpacer />
						<Skeleton width="100%" height="20px" />
						<Skeleton width="100%" height="20px" />
						<Skeleton width="100%" height="20px" />
						<Skeleton width="100%" height="20px" />
						<Skeleton width="100%" height="20px" />
						<Skeleton width="100%" height="20px" />
					</Column>
					<Column tablet="10%"></Column>
					<Column tablet="30%">
						<StyledBox>
							<Skeleton width="40%" height="40px" widthRandomness="0" />
							<StyledSpacer />
							<StyledSpacer />
							<Skeleton width="100%" height="20px" />
							<Skeleton width="100%" height="20px" />
							<Skeleton width="100%" height="20px" />
							<Skeleton width="100%" height="20px" />
							<StyledSpacer />
						</StyledBox>
					</Column>
				</Columns>
			</StyledMainContent>
		</StyledLoader>
	);
};

export default ApartmentDetailsLoader;
